/**
 * Asynchronously loads the component for EmailsGridPage
 */

import { lazyLoad } from 'utils/loadable';

export const EmailsGridPage = lazyLoad(
  () => import('./index'),
  module => module.EmailsGridPage,
);
